import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import ButtonElement from "../../Common/ButtonElement";
import ImageElement from "../../Common/ImageElement";
import InputElement from "../../Common/InputElement";
import { appImages } from "../../constants";
import { getCookie, setCookie, validateFields, commonOnChange } from "../../utils";
import { loginUser } from "../../actions/auth";
import "./auth.css";

const Login = () => {
    const [state, setState] = useState({
        email: "",
        password: "",
        loading: false,
        emailErr: null,
        remember: false,
        passwordErr: null
    });
    const dispatch = useDispatch();
    const { email, password, loading, remember, emailErr, passwordErr } = state;

    const submit = () => {
        const isPhoneNo = (/^\+?\d{10,15}$/.test(email));
        validateFields(
            {
                emailErr: [email, isPhoneNo ? "phone" : "email"],
                passwordErr: [password, "password"]
            },
            setState,
            () => {
                setState((prev) => ({ ...prev, passwordErr: null, emailErr: null, loading: true }));
                if (remember) {
                    setCookie("userEmail", email, 30);
                    setCookie("userPassword", password, 30);
                }
                dispatch(loginUser({ [isPhoneNo ? "mobileNo" : "email"]: email, password }, () => {
                    setState((prev) => ({ ...prev, loading: false }));
                }));
            }
        )
    }

    useEffect(() => {
        const userEmail = getCookie("userEmail");
        const userPassword = getCookie("userPassword");
        setState((prev) => ({ ...prev, email: userEmail, password: userPassword }));
    }, [])

    return <div className="login-container row">
        <div className="logo-box col-md-6">
            <ImageElement src={appImages.logo} imgStyle={{ height: "200px"}} alt="main-logo" />
        </div>
        <div className="login-box col-md-6">
            <div>
                <div className="logo">
                    <ImageElement src={appImages.logo} alt="login-log" />
                </div>

                <div className="login-title">
                    <h2 className="pb-1">Log in to your account</h2>
                    <p className="pb-1">Welcome back! Please enter your details.</p>
                </div>

                <div>
                    <div className='mb-3'>
                        <InputElement
                            label={"Email / Phone No"}
                            placeholder={"Email / Phone No"}
                            name={"email"}
                            value={email}
                            error={emailErr}
                            onChange={(event) => commonOnChange(event, setState)}
                        />
                    </div>

                    <div className='mb-3'>
                        <InputElement
                            label={"Password"}
                            placeholder={"*********"}
                            name={"password"}
                            value={password}
                            error={passwordErr}
                            onChange={(event) => commonOnChange(event, setState)}
                            type="password" />
                    </div>

                    <div className="remember-forgot mb-3">
                        <div className="d-flex align-items-center justify-content-center">
                            <input type="checkbox" id="agree" className="me-2" value={remember} onChange={() => setState((prev) => ({ ...prev, remember: !remember }))} />
                            <label htmlFor="agree">Remember me</label>
                        </div>
                        <span className="action-text-left">Forgot password?</span>
                    </div>

                    <ButtonElement text="Submit" cssClass="w-100 mt-2 more-radius" onClick={submit} variant="btn-primary" loading={loading} />
                </div>
            </div>
        </div>
    </div>
}

export default Login;